import clsx from 'clsx';
import useMapSearchItemStyles from '../styles';

export interface BoldMatchProps {
  text?: string;
  textToMatch?: string;
}

export const BoldMatch: React.FC<BoldMatchProps> = ({ text, textToMatch }) => {
  const classes = useMapSearchItemStyles();
  const textToMatchLength = textToMatch?.length;
  const offset = !textToMatch
    ? -1
    : text?.toLowerCase().search(RegExp.escape(textToMatch.toLowerCase())) ?? -1;
  if (!text || !textToMatchLength || textToMatchLength === 0 || offset < 0) {
    return <pre className={classes.wholeTextItem}>{text}</pre>;
  }
  const matchedText = text.substring(offset, offset + textToMatchLength);
  const stringBefore = text.substring(0, offset);
  const stringAfter = text.substring(offset + textToMatchLength);
  return (
    <span className={clsx(classes.textWrapper)}>
      <pre className={classes.textItem}>
        {stringBefore}
        <b>{matchedText}</b>
        {stringAfter}
      </pre>
    </span>
  );
};
